export default {
  alertInfo: {
    'versionCreatable': {
      title: '確認要更新版本嗎？',
      description: '將會啟動法規鑑別作業',
      btnText: '確認',
      color: 'primary',
    },
    'versionUnCreatable': {
      title: '目前無法進行法規鑑別',
      description: '相關公版的相關法規正在進行法規鑑別，必須先等進行中的法規鑑別完成發布',
      btnText: '知道了',
    },
    'releaseActCommentNotification': {
      title: '確認要發布ESGoal評析通知嗎？',
      btnText: '確認',
      color: 'primary',
    },
    'createCommentIdtf': {
      title: '確認要建立評析鑑別嗎？',
      btnText: '確認',
      color: 'primary',
    },
    'deleteArticle': {
      title: '確認要從此法規版本解除綁定此法條嗎？',
      btnText: '確認',
      color: 'primary',
    },
  }
};